import { useContext } from 'react';
import { useQuery } from 'react-query';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { acme_api } from '@axo/shared/data-access/api';
import { acme } from '@axo/shared/data-access/types';
import { acmeKeys } from '../../cache-keys/acmeKeys';

export function useArchiveSearch(query: acme.ArchiveSearchReq) {
  const api = useAPI();

  const ctx = useContext(DataAccessContext);
  const token = ctx?.state?.user?.token ?? '';

  return useQuery({
    queryKey: acmeKeys.archiveSearch(query),
    queryFn: ({ queryKey: [, , query] }) => acme_api.archiveSearch(api)(query),
    enabled: token.length > 0 && query.query !== '',
  });
}
